import { AcceptanceStatus, SubjectAction } from '@dealstack/shared/lib/generated';

export const hasUnconfirmedKycFiles = (
	files: Array<{ subjectAction?: SubjectAction | null } | undefined | null>
): boolean => files.some((f) => f?.subjectAction === SubjectAction.NOT_YET_ACTED);

export const isKycRejected = (status?: AcceptanceStatus | null): boolean =>
	status === AcceptanceStatus.REJECTED || status === AcceptanceStatus.REREQUESTED;
